export default __webpack_public_path__ + "media/zurb/img/experience-design/usability_audit-0f2ead3d52c8ea574502b29a7130f94f.png";